import feathersClient from '../../feathers';
import { fetchLegalNewsStart, fetchLegalNewsSuccess, fetchLegalNewsFailure } from '../slices/legalNewsSlice';
import { AppThunkDispatch } from '../../common/types/common-root-state-type';

export const fetchLegalNewsThunk = (jurisdiction: string = 'CYPRUS') => async (dispatch: AppThunkDispatch) => {
  try {
    dispatch(fetchLegalNewsStart());
    
    const response = await feathersClient.service('legal-news').find({
      query: {
        jurisdiction,
        $sort: { publishedAt: -1 },
        $limit: 50
      }
    });
    
    // Cast appropriately since we just created the service
    const items = (response as any).data || response;
    
    dispatch(fetchLegalNewsSuccess({
      items,
      fetchedAt: new Date().toISOString()
    }));
  } catch (error: any) {
    console.error('Error fetching legal news:', error);
    dispatch(fetchLegalNewsFailure(error.message || 'Failed to fetch legal news'));
  }
};
